var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgCalendar",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgCalendar{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M5.2,11.8h7.7c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.3-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H5.2c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3C4.7,11.6,4.9,11.8,5.2,11.8 C5.2,11.8,5.2,11.8,5.2,11.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M5.2,8.5h7.7c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.3-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H5.2C4.9,7.5,4.7,7.7,4.7,8C4.7,8.3,4.9,8.5,5.2,8.5C5.2,8.5,5.2,8.5,5.2,8.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_738",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M6.6,2.9h4.8v1H6.6V2.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M5.2,5.2c0.1,0,0.3-0.1,0.3-0.1C5.6,5,5.7,4.9,5.7,4.8V2.1c0-0.3-0.2-0.5-0.5-0.5c0,0,0,0,0,0 C5,1.6,4.9,1.6,4.8,1.7C4.7,1.8,4.7,1.9,4.7,2.1v2.7C4.7,5,4.9,5.2,5.2,5.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M15.4,2.9h-1.1v1h1.1c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.3,0.8-0.8,0.8H2.6 c-0.4,0-0.8-0.4-0.8-0.8V4.7c0-0.4,0.3-0.8,0.8-0.8h1.2v-1H2.6c-1,0-1.8,0.8-1.8,1.8v9.9c0,1,0.8,1.8,1.8,1.8h12.8 c1,0,1.8-0.8,1.8-1.8V4.7C17.2,3.7,16.4,2.9,15.4,2.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    className: "svgCalendar svgBase svgHover svgSelect",
    d: "M12.8,5.2c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0V2.1c0-0.3-0.2-0.5-0.5-0.5c0,0,0,0,0,0 c-0.3,0-0.5,0.2-0.5,0.5c0,0,0,0,0,0v2.7C12.3,5,12.6,5.2,12.8,5.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.eaa70c36.svg";
export { ForwardRef as ReactComponent };